<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.holidays.holidays') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
        </d-button>
      </d-col>
    </d-row>

    <d-row
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <label class="mt-2 mr-2 mb-0">
        {{ $t('settings.holidays.year') }}:
      </label>
      <d-form-select
        v-model="filters.year"
        :options="yearsOptions"
        style="width: 120px;" />
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('settings.holidays.date') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.holidays.name') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.holidays.internationalName') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.holidays.countryCode') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(holiday, index) of holidays"
            :key="'holiday-' + index">
            <td class="align-middle">
              {{ holiday.date }}
            </td>
            <td class="align-middle">
              {{ holiday.local_name }}
            </td>
            <td class="align-middle">
              {{ holiday.name }}
            </td>
            <td class="align-middle">
              {{ holiday.country_code }}
            </td>
          </tr>
          <tr v-if="holidays.length === 0">
            <td
              colspan="4"
              class="text-center">
              {{ $t('settings.holidays.noHolidaysToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'holidays',
  computed: {
    yearsOptions () {
      let firstYear = 2026;
      let lastYear = new Date().getFullYear() + 1;
      let years = [];

      for (let year = firstYear; year <= lastYear; year++) {
        years.push({
          value: year,
          text: year
        });
      }

      return years;
    }
  },
  watch: {
    'filters.year': function () {
      this.loadData();
    }
  },
  data() {
    return {
      filters: {
        year: new Date().getFullYear()
      },
      holidays: [],
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.loaded = false;
      ListUtils.loadItemsData(this, '/holidays/items?where[year]=' + this.filters.year, 'holidays', {}, 'get');
    }
  }
};
</script>
